import { createContext } from 'react';
import { defaultState, useModalManagerState } from './useModalManagerState';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultContextValue = {
  modals: defaultState.modals,
  register: () => {},
  shouldRender: () => false,
  unregister: () => {},
  isIdRegistered: () => false
};
export const ModalManagerContext = /*#__PURE__*/createContext(defaultContextValue);
export function ModalManagerProvider(_ref) {
  let {
    children
  } = _ref;
  const {
    state,
    register,
    shouldRender,
    unregister,
    isIdRegistered
  } = useModalManagerState();
  return /*#__PURE__*/_jsx(ModalManagerContext.Provider, {
    value: {
      ...state,
      register,
      shouldRender,
      unregister,
      isIdRegistered
    },
    children: children
  });
}